import WorkerApiService from "../workerApiServices"

class ReceitaServicoService extends WorkerApiService {

    constructor() {
        super('/api/receitaServico')
    }

    search(dataInicial, dataFinal){
        let params = `?`
        params = `${params}&dataInicial=${dataInicial}`
        params = `${params}&dataFinal=${dataFinal}`
        return this.get(`/search${params}`)
    }

    create(object){
        return this.post("/create", object)
    }    

    edit(object){
        return this.put("/edit", object)
    }    

    deleteById(id){
        return this.delete(`/delete/${id}`)
    }    


}

export default ReceitaServicoService